// src/config/pipelineConfig.js
import JobFormCRO from "../components/Jobs/JobFormCRO";
import JobFormSARS from "../components/Jobs/JobFormSARS";
import JobFormCauris from "../components/Jobs/JobFormCauris";
import JobFormPhylo from "../components/Jobs/JobFormPhylo";

/**
 * /**
 * Mainly Imported by Dashboard, Sidebar and App
 */
export const PIPELINE_CONFIG = [
  {
    id: 1,
    code: "cro",
    shortName: "CRO",
    sideBarName: "CRO",
    title:"Carbapenem Resistance (CRO)",
    data: "CRO",
    pipeline_n: "Phoenix",
    description: (
      <>
        CRO Data Analysis utilizes{" "}
        <a
          href="https://github.com/CDCgov/phoenix"
          target="_blank"
          rel="noopener noreferrer"
        >  
        <strong>PHoeNIx</strong>
        </a>
        , developed and maintained by the{" "}
        <a
          href="https://www.cdc.gov/hai/organization/dhqp.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          CDC’s Division of Healthcare Quality Promotion (DHQP)
        </a>, to support genomic surveillance of healthcare-associated bacterial pathogens.
        <div style={{ marginTop: "6px", lineHeight: "1.5" }}>
          Sequencing data shared via{" "}
        <a
          href="https://basespace.illumina.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Illumina BaseSpace
        </a>{" "} are securely processed on our
          high-performance computing (HPC) infrastructure. The pipeline performs
          standardized quality control, genome assembly, multilocus sequence typing
          (MLST), plasmid detection, and identification of antimicrobial resistance
          and hypervirulence determinants.
        </div>
      </>

    ),
    icon: "nc-icon nc-chart-pie-35",
    path: "/dashboard/cro",
    apiEndpoint: "/api/jobs/createcro",
    formComponent: JobFormCRO  
  },
  {
    id: 2,
    code: "sars-cov-2",
    shortName: "SARS-CoV-2",
    sideBarName: "SARS-CoV-2",
    title:"SARS-CoV-2",
    data:"SARS-CoV-2",
    pipeline_n: "Cecret",
    description: (
      <>
        SARS-CoV-2 analysis uses{" "} 
        <a
          href="https://github.com/UPHL-BioNGS/Cecret"
          target="_blank"
          rel="noopener noreferrer"
        >
          <strong>Cecret</strong>
          </a>, a Linux-based Nextflow pipeline for
        SARS-CoV-2 sequencing. 
        <div style={{ marginTop: "6px", lineHeight: "1.5" }}>
          Sequencing data shared via{" "}
          <a
            href="https://basespace.illumina.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Illumina BaseSpace
          </a>{" "}
          are securely processed on our high-performance computing (HPC) infrastructure. 
          The pipeline performs quality control, read cleaning, alignment, variant calling, 
          consensus generation, lineage and clade classification, multiple sequence alignment, and phylogenetic analysis.
        </div>
    </>

    ),
    icon: "nc-icon nc-chart-pie-35",
    path: "/dashboard/sars-cov-2",
    apiEndpoint: "/api/jobs/createsars",
    formComponent: JobFormSARS  
  },
  {
    id: 3,
    code: "cauris",
    shortName: "C.auris",
    sideBarName: "C.auris",
    title:"Candida auris",
    data:"C.auris",
    pipeline_n: "MycoSNP",
    description: (
      <>
        Cauris Data Analysis uses{" "}
        <a
          href="https://github.com/CDCgov/mycosnp-nf"
          target="_blank"
          rel="noopener noreferrer"
        ><strong>MycoSNP</strong>
        </a> ,
        a bioinformatics pipeline for whole-genome sequencing analysis of fungal organisms, 
        including <em>Candida auris</em>, from Illumina paired-end reads. 
        Built with the nf-core template, it provides both a pre-analysis workflow 
        for rapid initial results and a main workflow for in-depth analysis.
        <div style={{ marginTop: "6px", lineHeight: "1.5" }}>
          Sequencing data shared via{" "}
          <a
            href="https://basespace.illumina.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Illumina BaseSpace
          </a>{" "}
          are securely processed on our high-performance computing (HPC) infrastructure. 
          The pipeline performs fungal taxonomic classification, Candida auris clade typing, 
          reference-based SNP calling, phylogenetic tree construction, and identification of 
          antifungal-resistance mutations.
        </div>
      </>
    ),
    icon: "nc-icon nc-chart-pie-35",
    path: "/dashboard/cauris",
    apiEndpoint: "/api/jobs/createcauris",
    formComponent: JobFormCauris  
  },
  {
    id: 4,
    code: "phylo",
    shortName: "PhyloTree",
    sideBarName: "PhyloTree",
    title:"Phylogeny Tree",
    data: "This analysis currently only supports C.auris data.",
    pipeline_n: "PhyloTree",
    description: (
      <>
        <strong>Phylogenetic tree analysis</strong> aligns FASTQ reads to a reference, generates a multi-FASTA from SNP positions, and constructs phylogenetic trees using tools such as{" "}
          <a
            href="https://github.com/somme89/rapidNJ"
            target="_blank"
            rel="noopener noreferrer"
          >
            rapidNJ
          </a>
          ,{" "}
          <a
            href="https://morgannprice.github.io/fasttree/"
            target="_blank"
            rel="noopener noreferrer"
          >
            FastTree2
          </a>
          , and{" "}
          <a
            href="https://github.com/k-florek/QuickSNP"
            target="_blank"
            rel="noopener noreferrer"
          >
            quickSNP
          </a>
          .        
        <div style={{ marginTop: "6px", lineHeight: "1.5" }}>
          Sequencing data shared via{" "}
          <a
            href="https://basespace.illumina.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Illumina BaseSpace
          </a>{" "}
          are securely processed on our high-performance computing (HPC) infrastructure.{" "}
          <strong style={{ color: "red" }}>
            This analysis currently only supports C.auris data.
          </strong>
        </div>
      </>


    ),
    icon: "nc-icon nc-chart-pie-35",
    path: "/dashboard/phylo",
    apiEndpoint: "/api/jobs/createphylo",
    formComponent: JobFormPhylo  
  }
];

/**
 * 
 * 
 */
export const getFormComponent = (code) => {
  const pipeline = PIPELINE_CONFIG.find(p => p.code === code);
  return pipeline?.formComponent || null;
};

/**
 * 
 */
export const FORM_MAP = PIPELINE_CONFIG.reduce((acc, pipeline) => {
  acc[pipeline.code] = pipeline.formComponent;
  return acc;
}, {});

/**
 * 
 */
// export const getDashboardRoutes = () => {
//   return PIPELINE_CONFIG.map(pipeline => ({
//     path: pipeline.path,
//     name: pipeline.sideBarName,
//     icon: pipeline.icon
//   })).concat([
//     { path: "/profile", name: "Profile", icon: "nc-icon nc-circle-09" }
//   ]);
// };
export const getDashboardRoutes = () => {
  return [
    {
      path: "/home",
      name: "Home",
      icon: "nc-icon nc-hat-3"
    },
    {
      path: "/tutorial",
      name: "Tutorial",
      icon: "nc-icon nc-hat-3"
    },


    ...PIPELINE_CONFIG.map(pipeline => ({
      path: pipeline.path,
      name: pipeline.sideBarName,
      icon: pipeline.icon
    })),

    {
      path: "/profile",
      name: "Profile",
      icon: "nc-icon nc-circle-09"
    }
  ];
};
/**
 * 
 */
export const getPipelineByCode = (code) => {
  return PIPELINE_CONFIG.find(p => p.code === code);
};

/**
 * 
 */
export const getPipelineByPath = (path) => {
  return PIPELINE_CONFIG.find(p => p.path === path);
};



// 默认导出所有工具
export default {
  PIPELINE_CONFIG,
  getFormComponent,
  FORM_MAP,
  getDashboardRoutes,
  getPipelineByCode,
  getPipelineByPath,
};